import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";
import { SelectPlanForm } from "@/components/forms/select-plan-form";
import { Steps } from "@/components/steps";
import { Button } from "@/components/ui/button";

export default function Plans() {
  const { service } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="space-y-12">
      <Steps className="mx-auto flex max-w-2xl" currentStep={1} />

      <SelectPlanForm serviceType={service as ServiceType} />

      <Button onClick={() => navigate(-1)} variant="outline">
        <ChevronLeft />
        <span>{t("labels.back")}</span>
      </Button>
    </div>
  );
}
